import { h } from '../dom.js';
import type { Series } from '../types.js';
import { navigate } from '../router.js';
import { flatCourses } from '../manifest.js';

export function SeriesGrid(series: Series[]): HTMLElement {
  return h(
    'section',
    { className: 'series-grid-wrap' },
    [
      h('header', { className: 'view-header' }, [
        h('h1', { className: 'view-title', text: '日语听力学习' }),
        h('p', { className: 'view-subtitle', text: '选择一个课程系列开始学习' }),
      ]),
      h(
        'div',
        { className: 'series-grid' },
        series.map((s) => renderCard(s)),
      ),
    ],
  );
}

function renderCard(s: Series): HTMLElement {
  const totalCourses = flatCourses(s).length;
  const cov = s.metaCoverage;
  const covPct = cov && cov.total > 0 ? Math.round((cov.done / cov.total) * 100) : 0;
  const layoutLabel = s.chapters ? `${s.chapters.length} 章 · ${totalCourses} 课` : `${totalCourses} 课`;

  return h(
    'button',
    {
      className: 'series-card',
      attrs: { type: 'button', 'data-id': s.id },
      on: {
        click: () => navigate({ name: 'series', seriesId: s.id }),
      },
    },
    [
      h('div', { className: 'series-card__title', text: s.title }),
      h('div', { className: 'series-card__meta' }, [
        h('span', { className: 'chip chip--layout', text: layoutLabel }),
        cov && cov.total > 0
          ? h('span', {
              className: `chip chip--cov ${cov.done === cov.total ? 'chip--cov-full' : cov.done > 0 ? 'chip--cov-partial' : 'chip--cov-none'}`,
              text: cov.done === cov.total ? `字幕全 (${cov.done}/${cov.total})` : cov.done > 0 ? `字幕 ${cov.done}/${cov.total}` : '暂无字幕',
            })
          : null,
      ]),
      h('div', { className: 'series-card__cov' }, [
        h('div', { className: 'series-card__cov-track' }, [
          h('div', {
            className: 'series-card__cov-fill',
            style: { width: `${covPct}%` } as Partial<CSSStyleDeclaration>,
          }),
        ]),
      ]),
    ],
  );
}
